import clsx from 'clsx'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import { ReactComponent as ArrowTop } from 'assets/icons/arrow-top.svg'
import { Icon } from 'components/common/Icon/Icon'
import { AnalyticsActionType } from 'types/common/analytics.type'

import styles from './PartnersSubhead.module.scss'
import { PartnersData } from './PartnersSubheadData'
import Cross from '../../assets/images/partners/cross.svg'
import Infinity from '../../assets/images/partners/infinity.gif'
import Arrow from '../../assets/images/partners/right_arrow.svg'
import { trackAnalytics } from '../../utils/analytics'
import Bubble from '../common/bubble/Bubble'
import Circle from '../common/circle/Circle'
import { Flex } from '../common/flex/Flex'
import TitleText from '../common/titleText/TitleText'
import { Typography } from '../common/Typography/Typography'

const title = 'Cross-Functional Partners'
const text = 'Discover the perfect partners for your futuristic thinking.'
const bubbleText = 'Best. Partners. Ever.'

const PartnersSubhead = () => {
  const [openDropdown, setOpenDropdown] = useState(false)

  const handleOpenDropdown = () => {
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: 'pg_act_innovation_cfp_expandcard',
    })
    if (!openDropdown) setOpenDropdown(true)
  }

  const handleCloseDropdown = () => {
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: 'pg_act_innovation_cfp_minimizecard',
    })
    if (openDropdown) setOpenDropdown(false)
  }

  return (
    <div className={styles.containerWrapper}>
      <Flex className={styles.container} onClick={handleOpenDropdown}>
        <div className={styles.leftImageContainer}>
          <img src={Infinity} alt="" />
        </div>
        <div className={styles.rightTextContainer}>
          <Typography type="4xl-display" className={styles.title}>
            {title}
          </Typography>
        </div>
        <Circle
          className={clsx(styles.circle, openDropdown ? styles.hide : styles.circleAnimation)}
          text="Explore Partners"
          textOnHover="Explore Partners"
        />
        <div className={styles.arrowContainer}>
          <img src={Arrow} alt="" />
        </div>
      </Flex>
      <Flex direction="column" className={clsx(styles.dropdownContainer, openDropdown && styles.active)}>
        <div className={styles.leftImageContainer}>
          <img src={Infinity} alt="" />
        </div>
        <TitleText
          containerClassName={styles.dropdownTitleContainer}
          titleTag="h3"
          titleClassName={styles.dropdownTitle}
          textClassName={styles.dropdownText}
          title={title}
          text={text}
        >
          <Bubble color="#EBFF00" text={bubbleText} className={styles.bubble} direction="down" />
        </TitleText>
        <Flex direction="row" gap={39} className={styles.dropdownCardContainer}>
          {PartnersData.map(partner => {
            return (
              <Flex key={partner.title} direction="column" className={styles.cardItem}>
                <div>
                  <partner.img />
                </div>
                <TitleText
                  titleType="xl-heading"
                  titleTag="p"
                  textType="m-body"
                  textTag="p"
                  title={partner.title}
                  text={partner.description}
                  textClassName={styles.dropdownContentText}
                  titleClassName={styles.dropdownContentTitle}
                  containerClassName={styles.dropdownTextContainer}
                />
                <Link
                  to={partner.link}
                  className={styles.link}
                  target="_blank"
                  onClick={() =>
                    trackAnalytics({
                      type: AnalyticsActionType.action,
                      payload: partner.event,
                    })
                  }
                >
                  <Typography type="s-heading" className={styles.linkText} color="#fff">
                    Learn More
                  </Typography>
                  <Icon icon={ArrowTop} color="ffffff" className={styles.icon} />
                </Link>
              </Flex>
            )
          })}
        </Flex>
        <div className={styles.rightImageContainer} onClick={handleCloseDropdown}>
          <img src={Cross} alt="" />
        </div>
      </Flex>
    </div>
  )
}

export default PartnersSubhead
